<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    title?: string
    modelValue?: boolean
  }>(),
  {
    title: '',
    modelValue: false
  }
)

const emit = defineEmits<{
  'update:modelValue': [state: boolean]
}>()

function toggle() {
  emit('update:modelValue', !props.modelValue)
}
</script>

<template>
  <div class="flex items-center py-1 gap-2" @click="toggle">
    <button
      type="button"
      aria-pressed="false"
      class="relative inline-flex items-center h-5 w-9 flex-shrink-0 cursor-pointer rounded-full bg-uiGray-300 border border-[#2E2E2F] transition-colors duration-200 ease-in-out focus:outline-none"
    >
      <span
        class="relative inline-block h-4 w-4 transform rounded-full shadow ring-0 transition duration-200 ease-in-out"
        :class="[
          modelValue
            ? 'translate-x-4 bg-uiPrimary-400'
            : 'translate-x-0.5 bg-uiGray-700'
        ]"
      >
        <span
          class="absolute inset-0 flex h-full w-full items-center justify-center transition-opacity"
          aria-hidden="true"
          :class="[
            modelValue
              ? 'opacity-0 ease-out duration-100'
              : 'opacity-100 ease-in duration-200'
          ]"
        >
        </span>
      </span>
    </button>
    <slot>
      <span class="text-sm text-uiGray-600 whitespace-nowrap">{{ title }}</span>
    </slot>
  </div>
</template>
